<ng-container [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-invoices-webshop *ngSwitchDefault></app-invoices-webshop>
</ng-container>
